import MwVueComponents from 'laravel-front-library';
import axios from 'axios';

const laravelFrontLibrary = {
	install: (app) => {
		app.use(MwVueComponents, {
			languages: {
				NL: '/images/flags/nl.svg',
				EN: '/images/flags/gb.svg',
				DE: '/images/flags/de.svg',
				FR: '/images/flags/fr.svg',
				ES: '/images/flags/es.svg',
			},
			singlePageApplication: false,
			locale: document.documentElement.lang,
			onError: window.Sentry.captureException,
			onWarning: window.Sentry.captureException,
			http: axios,
		});
	}
};

export default laravelFrontLibrary;
